import { store } from '@/app/store';
import { selectAllPortfolioBalances, useGetPortfolioBalancesQuery } from '@/features/balance/balancesApi';
import { selectIsLoggedIn } from '@/features/oAuth/oAuthSlice';
import { getEuroFormat } from '@/shared/helpers/formatters';
import { calculateEuroValue } from '@/shared/helpers/portfolioHelpers';
import { userCanTrade } from '@/shared/hooks/user';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import GenericErrorComponent from '../GenericErrorComponent/GenericErrorComponent';
import styles from './PortfolioValue.module.css';
import { useMarketInfo } from '@/shared/hooks/market';

const PortfolioValue: React.FC = () => {
  const { t } = useTranslation();
  const assetsPortfolioBalances = selectAllPortfolioBalances(store.getState());

  const isLoggedIn = useSelector(selectIsLoggedIn);

  const { marketsInfo } = useMarketInfo();

  const totalPortfolioValue = useMemo(() => {
    const walletBalances = calculateEuroValue(assetsPortfolioBalances, marketsInfo);

    return walletBalances.reduce((total, assetBalance) => total + Number(assetBalance.euroValue ?? 0), 0);
  }, [assetsPortfolioBalances, marketsInfo]);

  const {
    isSuccess: portfolioBalancesSuccess,
    isFetching: portfolioBalancesFetching,
    error: portfolioBalancesError
  } = useGetPortfolioBalancesQuery(undefined, {
    skip: !isLoggedIn
  });

  const showPortfolioValue = portfolioBalancesSuccess && userCanTrade;
  const portfolioValueEuros = showPortfolioValue
    ? getEuroFormat(totalPortfolioValue)
    : portfolioBalancesFetching
      ? '...'
      : getEuroFormat(0);

  const isServerError = () => {
    if (portfolioBalancesError && 'status' in portfolioBalancesError && portfolioBalancesError.status === 500) {
      return true;
    }
  };

  return (
    <>
      <div className={styles.container}>
        <h1 className={styles.amount}>{portfolioValueEuros}</h1>
        <span className={styles.label}>{t('portfolio.topLabel')}</span>
      </div>
      {isServerError() && <GenericErrorComponent />}
    </>
  );
};

export default PortfolioValue;
